module.exports = __webpack_public_path__ + "img/arrow-left.76949596.svg";